import {AdvanceEmiPlan} from './AdvanceEmiPlan';

export class LoanApplication {
    public id: string;
    public shortId: string;
    public amount: number;
    public reason: string;
    public userId: string;
    public tenure: number;
    public addressId: string;
    public bankAccountId: string;
    public advanceEmiPlan: AdvanceEmiPlan;
    public partnerId: string;
    public nonRetail?: boolean;
    public creditReportId?: string;
    public creditOptionId?: string;
    public createdAt?: Date;
    public updatedAt?: Date;

    constructor(
        loanAmount: number,
        loanReason: string,
        userId: string,
        tenure: number,
        partnerId?: string,
        advanceEmiPlan?: AdvanceEmiPlan,
        shortId?: string,
        nonRetail?: boolean,
        creditReportId?: string,
        creditOptionId?: string
    ) {
        this.shortId = shortId;
        this.amount = loanAmount;
        this.reason = loanReason;
        this.userId = userId;
        this.tenure = tenure;
        this.advanceEmiPlan = advanceEmiPlan;
        this.partnerId = partnerId;
        this.nonRetail = nonRetail;
        this.creditReportId = creditReportId;
        this.creditOptionId = creditOptionId;
    }
}
